import React, { useEffect, useState } from "react";
import { AppSettings } from "./config/app-settings.js";
import { slideToggle } from "./composables/slideToggle.js";

import Header from "./components/header/header.jsx";
import Sidebar from "./components/sidebar/sidebar.jsx";
import SidebarUtils from "./components/sidebar/sidebar-utils.jsx";
import SidebarRight from "./components/sidebar-right/sidebar-right.jsx";
import TopMenu from "./components/top-menu/top-menu.jsx";
import Content from "./components/content/content.jsx";
import ThemePanel from "./components/theme-panel/theme-panel.jsx";
import RedirectHandler from "./components/auth/RedirectHandler.jsx";

function App() {
  const [appTheme] = useState("");
  const [appClass, setAppClass] = useState("");
  const [appDarkMode, setAppDarkMode] = useState(false);
  const [appGradientEnabled, setAppGradientEnabled] = useState(true);
  const [appHeaderNone, setAppHeaderNone] = useState(false);
  const [appHeaderFixed, setAppHeaderFixed] = useState(true);
  const [appHeaderInverse, setAppHeaderInverse] = useState(false);
  const [hasScroll, setHasScroll] = useState(false);
  const [appSidebarNone, setAppSidebarNone] = useState(false);
  const [appSidebarWide, setAppSidebarWide] = useState(false);
  const [appSidebarLight, setAppSidebarLight] = useState(false);
  const [appSidebarMinify, setAppSidebarMinify] = useState(false);
  const [appSidebarMobileToggled, setAppSidebarMobileToggled] = useState(false);
  const [appSidebarTransparent, setAppSidebarTransparent] = useState(false);
  const [appSidebarFixed, setAppSidebarFixed] = useState(true);
  const [appSidebarGrid, setAppSidebarGrid] = useState(false);
  const [appContentNone, setAppContentNone] = useState(false);
  const [appContentClass, setAppContentClass] = useState("");
  const [appContentFullHeight, setAppContentFullHeight] = useState(false);
  const [appSidebarEnd, setAppSidebarEnd] = useState(false);
  const [appSidebarEndToggled, setAppSidebarEndToggled] = useState(false);
  const [appSidebarEndMobileToggled, setAppSidebarEndMobileToggled] = useState(false);
  const [themePanelNone, setThemePanelNone] = useState(false);
  const [appHeaderMegaMenu, setAppHeaderMegaMenu] = useState(false);
  const [appTopMenu, setAppTopMenu] = useState(false);
  const [appTopMenuMobileToggled] = useState(false);
  const [appSidebarTwo, setAppSidebarTwo] = useState(false);
  
  
  // Business logic states (THIS AND METHODS ASSOCIATED MUST BE REFACTORED INTO ZUSTAND OR REACT QUERY LATER)
  const [sidebarUtilsContent, setSidebarUtilsContent] = useState({
    component: null,
    props: {},
  });
  const [sidebarRightContent, setSidebarRightContent] = useState({
    component: null,
    props: {},
  });
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [currentPercentage, setCurrentPercentage] = useState(100);
  const [tcpEnabled, setTcpEnabled] = useState(false);
  const [effectiveLanes, setEffectiveLanes] = useState(1.0);
  const [selectedTAZ, setSelectedTAZ] = useState(null);
  const [currentEvent, setCurrentEvent] = useState(null);

  

  const handleSetAppClass = (value) => {
    setAppClass(value);
  };

  const handleSetAppHeaderNone = (value) => {
    setAppHeaderNone(value);
  };

  const handleSetAppHeaderInverse = (value) => {
    setAppHeaderInverse(value);
  };

  const handleSetAppHeaderFixed = (value) => {
    if (value === false && appSidebarFixed) {
      alert(
        "Default Header with Fixed Sidebar option is not supported. Proceed with Default Header with Default Sidebar."
      );
      setAppSidebarFixed(false);
      if (localStorage) {
        localStorage.appSidebarFixed = false;
      }
    }
    setAppHeaderFixed(value);
    if (localStorage) {
      localStorage.appHeaderFixed = value;
    }
  };

  const handleSetAppSidebarNone = (value) => {
    setAppSidebarNone(value);
  };

  const handleSetAppSidebarWide = (value) => {
    setAppSidebarWide(value);
  };

  const handleSetAppSidebarLight = (value) => {
    setAppSidebarLight(value);
  };

  const handleSetAppSidebarMinified = (value) => {
    setAppSidebarMinify(value);
  };

  const handleSetAppSidebarTransparent = (value) => {
    setAppSidebarTransparent(value);
  };

  const handleSetAppSidebarFixed = (value) => {
    if (value === true && !appHeaderFixed) {
      alert(
        "Default Header with Fixed Sidebar option is not supported. Proceed with Fixed Header with Fixed Sidebar."
      );
      setAppHeaderFixed(true);
      if (localStorage) {
        localStorage.appHeaderFixed = true;
      }
    }
    setAppSidebarFixed(value);
    if (localStorage) {
      localStorage.appSidebarFixed = value;
    }
  };

  const handleSetAppSidebarGrid = (value) => {
    setAppSidebarGrid(value);
    if (localStorage) {
      localStorage.appSidebarGrid = value;
    }
  };

  const toggleAppSidebarMinify = (e) => {
    e.preventDefault();
    setAppSidebarMinify(!appSidebarMinify);
    if (localStorage) {
      localStorage.appSidebarMinify = !appSidebarMinify;
    }
  };

  const toggleAppSidebarMobile = (e) => {
    e.preventDefault();
    setAppSidebarMobileToggled(!appSidebarMobileToggled);
  };

  const handleSetAppSidebarEnd = (value) => {
    setAppSidebarEnd(value);
  };

  const handleSetAppContentNone = (value) => {
    setAppContentNone(value);
  };

  const handleSetAppContentClass = (value) => {
    setAppContentClass(value);
  };

  const handleSetAppContentFullHeight = (value) => {
    setAppContentFullHeight(value);
  };

  const handleSetAppDarkMode = (value) => {
    if (value === true) {
      document.querySelector("html").setAttribute("data-bs-theme", "dark");
    } else {
      document.querySelector("html").removeAttribute("data-bs-theme");
    }
    setAppDarkMode(value);
    if (localStorage) {
      localStorage.appDarkMode = value;
    }
    document.dispatchEvent(new Event("theme-reload"));
  };

  const handleSetAppGradientEnabled = (value) => {
    setAppGradientEnabled(value);
    if (localStorage) {
      localStorage.appGradientEnabled = value;
    }
  };

  const handleSetAppTheme = (value) => {
    var newTheme = "theme-" + value;
    for (var x = 0; x < document.body.classList.length; x++) {
      if (
        document.body.classList[x].indexOf("theme-") > -1 &&
        document.body.classList[x] !== newTheme
      ) {
        document.body.classList.remove(document.body.classList[x]);
      }
    }
    document.body.classList.add(newTheme);

    if (localStorage && value) {
      localStorage.appTheme = value;
    }
    document.dispatchEvent(new Event("theme-reload"));
  };

  const toggleAppSidebarEnd = (e) => {
    e.preventDefault();
    setAppSidebarEndToggled(!appSidebarEndToggled);
  };

  const toggleAppSidebarEndMobile = (e) => {
    e.preventDefault();
    setAppSidebarEndMobileToggled(!appSidebarEndMobileToggled);
  };

  const handleSetThemePanelNone = (value) => {
    setThemePanelNone(value);
  };

  const handleSetAppSidebarTwo = (value) => {
    setAppSidebarTwo(value);
    setAppSidebarEndToggled(value);
  };

  const handleSetSelectedFeature = (feature) => {
    setSelectedFeature(feature);
  };

  const handleSetSelectedTAZ = (TAZ) => {
    setSelectedTAZ(TAZ);
  }

  const handleSetAppHeaderMegaMenu = (value) => {
    setAppHeaderMegaMenu(value);
  };

  const handleSetAppTopMenu = (value) => {
    setAppTopMenu(value);
  };

  const toggleAppTopMenuMobile = (e) => {
    e.preventDefault();
    slideToggle(document.querySelector(".app-top-menu"));
  };

  const handleSetSidebarUtilsContent = (componentsArray) => {
    setSidebarUtilsContent(componentsArray);
  };

  const handleClearSidebarUtilsContent = () => {
    setSidebarUtilsContent({ component: null, props: {} });
  };

  const handleSetSidebarRightContent = (component, props = {}) => {
    setSidebarRightContent({ component, props });
  };

  const handleClearSidebarRightContent = () => {
    setSidebarRightContent({ component: null, props: {} });
  };

  const handleSetCurrentEvent = (event) => {
    setCurrentEvent(event);
  };

  const handleSetCurrentPercentage = (percentage) => {
    setCurrentPercentage(percentage);
  };
  
  const handleSetTcpEnabled = (enabled) => {
    setTcpEnabled(enabled);
  };

  const handleSetEffectiveLanes = (lanes) => {
    setEffectiveLanes(lanes);
  };

  // Dark mode & scroll detection
  useEffect(() => {
    handleSetAppTheme(appTheme);
    if (appDarkMode) {
      handleSetAppDarkMode(true);
    }

    const handleScroll = () => {
      if (window.scrollY > 0) {
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
      var elm = document.getElementsByClassName("nvtooltip");
      for (var i = 0; i < elm.length; i++) {
        elm[i].classList.add("d-none");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [appTheme, appDarkMode]);

  return (
    <>
      <RedirectHandler />

      <AppSettings.Provider
        value={{
          appTheme,
          handleSetAppTheme,
          appClass,
          handleSetAppClass,
          appDarkMode,
          handleSetAppDarkMode,
          appGradientEnabled,
          handleSetAppGradientEnabled,
          appHeaderFixed,
          handleSetAppHeaderFixed,
          appHeaderInverse,
          handleSetAppHeaderInverse,
          hasScroll,
          appHeaderNone,
          handleSetAppHeaderNone,
          appSidebarNone,
          handleSetAppSidebarNone,
          appSidebarWide,
          handleSetAppSidebarWide,
          appSidebarLight,
          handleSetAppSidebarLight,
          appSidebarMinify,
          handleSetAppSidebarMinified,
          toggleAppSidebarMinify,
          appSidebarMobileToggled,
          toggleAppSidebarMobile,
          appSidebarTransparent,
          handleSetAppSidebarTransparent,
          appSidebarFixed,
          handleSetAppSidebarFixed,
          appSidebarGrid,
          handleSetAppSidebarGrid,
          appContentClass,
          handleSetAppContentClass,
          appContentNone,
          handleSetAppContentNone,
          appContentFullHeight,
          handleSetAppContentFullHeight,
          appSidebarEnd,
          handleSetAppSidebarEnd,
          toggleAppSidebarEnd,
          appSidebarEndToggled,
          setAppSidebarEndToggled,
          toggleAppSidebarEndMobile,
          appSidebarEndMobileToggled,
          themePanelNone,
          handleSetThemePanelNone,
          // Navigation menu
          appTopMenu,
          appTopMenuMobileToggled,
          toggleAppTopMenuMobile,
          handleSetAppTopMenu,
          appHeaderMegaMenu,
          handleSetAppHeaderMegaMenu,
          // Second sidebar (right) with selected leaflet geojson feature details & sidebar utils dynamic content
          appSidebarTwo,
          handleSetAppSidebarTwo,
          selectedFeature,
          handleSetSelectedFeature,
          selectedTAZ,
          handleSetSelectedTAZ,
          sidebarRightContent,
          handleSetSidebarRightContent,
          handleClearSidebarRightContent,
          sidebarUtilsContent,
          handleSetSidebarUtilsContent,
          handleClearSidebarUtilsContent,
          // Current Event
          currentEvent,
          handleSetCurrentEvent,
					// Context variables	
          currentPercentage,
          handleSetCurrentPercentage,
          tcpEnabled,
          setTcpEnabled,
          handleSetTcpEnabled,
          effectiveLanes,
          handleSetEffectiveLanes,
        }}
      >
        <div
          className={
            "app " +
            (appClass ? appClass + " " : "") +
            (appGradientEnabled ? "app-gradient-enabled " : "") +
            (appHeaderNone ? "app-without-header app-header-none " : "") +
            (appHeaderFixed && !appHeaderNone ? "app-header-fixed " : "") +
            (appSidebarFixed ? "app-sidebar-fixed " : "") +
            (appSidebarNone ? "app-without-sidebar " : "") +
            (appSidebarEnd ? "app-with-end-sidebar " : "") +
            (appSidebarWide ? "app-with-wide-sidebar " : "") +
            (appSidebarMinify ? "app-sidebar-minified " : "") +
            (appSidebarMobileToggled ? "app-sidebar-mobile-toggled " : "") +
            (appTopMenu ? "app-with-top-menu " : "") +
            (appContentFullHeight ? "app-content-full-height " : "") +
            (appSidebarTwo ? "app-with-two-sidebar " : "") +
            (appSidebarEndToggled ? "app-sidebar-end-toggled " : "") +
            (appSidebarEndMobileToggled
              ? "app-sidebar-end-mobile-toggled "
              : "") +
            (hasScroll ? "has-scroll " : "")
          }
        >
          {!appHeaderNone && <Header />}
          {!appSidebarNone && <SidebarUtils />}
          {appSidebarTwo && <SidebarRight />}
          {appTopMenu && <TopMenu />}
          {!appContentNone && <Content />}
          {/* {!themePanelNone && <ThemePanel />} */}
        </div>
      </AppSettings.Provider>
    </>
  );
}

export default App;
